import React from 'react';
import { useNavigate } from 'react-router-dom';
import { useMsal } from '../contexts/useMsal';

/**
 * Main menu landing page for multi-cloud platform selection
 * 
 * Accessibility features:
 * - ARIA labels for screen readers
 * - Keyboard navigation support
 * - High contrast color ratios (WCAG 2.1 AA compliant)
 * - Clear focus indicators
 * - Semantic HTML structure
 */
const MenuPage: React.FC = () => {
  const navigate = useNavigate();
  const { user } = useMsal();

  const handleNavigation = (path: string) => {
    navigate(path);
  };

  return (
    <div className="menu-container">
      <div className="menu-content">
        <div className="menu-header">
          <h1>Cloud Account Management</h1>
          <p className="menu-subtitle">
            Select a cloud platform to manage billing accounts and subscriptions
          </p>
        </div>

        <nav className="menu-cards" aria-label="Cloud platform selection">
          {/* Test Fabric Card */}
          <button
            className="menu-card menu-card-active"
            onClick={() => handleNavigation('/test')}
            aria-label="Go to Test Fabric Account Management"
          >
            <div className="menu-card-icon" aria-hidden="true">
              <svg width="48" height="48" viewBox="0 0 48 48" fill="none">
                <rect width="48" height="48" rx="8" fill="#0078D4" fillOpacity="0.1" />
                <path d="M16 14L24 12L32 18L28 34L16 32L14 20L16 14Z" fill="#0078D4" />
              </svg>
            </div>
            <h2 className="menu-card-title">Test Fabric</h2>
            <p className="menu-card-description">
              Manage Test Fabric billing accounts and linked accounts
            </p>
            <div className="menu-card-footer">
              <span className="menu-card-arrow" aria-hidden="true">→</span>
            </div>
          </button>
        </nav>

        <div className="menu-footer">
          <p className="menu-footer-text">
            Logged in as <strong>{user?.displayName || user?.mail}</strong>
          </p>
        </div>
      </div>
    </div>
  );
};

export default MenuPage;
